import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { SButton, SLoader } from '@strana-artw/ui-kit';
import { storeToRefs } from 'pinia';
import { computed, defineComponent, onBeforeMount, onBeforeUnmount, ref, useCssModule } from 'vue';
import { useNotify } from '@/app/providers/notify';
import { useLegalDocuments, useUserRole } from '@/shared/composables';
import { fullLogDecorate } from '@/shared/lib';
import { getErrorMessageTyped, pageScrollService } from '@/shared/services';
import { AppTitle } from '@/shared/ui';
import { GenericAcceptPolicy, RegistrationPolicy } from '@/shared/ui/policies';
import { useAuthStore } from '@/store/authStore';
import { useLegalDocumentsStore } from '@/store/documents';
import { useFeatureFlagsStore } from '@/store/featureFlags';
export default /*#__PURE__*/_defineComponent({
  __name: 'ModalAcceptedLegalDocuments',
  setup: function setup(__props) {
    /* TODO: создать родительский компонент т.к. используется в двух места */
    defineComponent({
      name: 'ModalAcceptedLegalDocuments'
    });
    var _useUserRole = useUserRole(),
      isAgent = _useUserRole.isAgent;
    var authStore = useAuthStore();
    var _storeToRefs = storeToRefs(authStore),
      isAggregator = _storeToRefs.isAggregator;
    var _useFeatureFlagsStore = useFeatureFlagsStore(),
      isAcceptPrivateFlag = _useFeatureFlagsStore.isAcceptPrivateFlag;
    var description = computed(function () {
      if (isAcceptPrivateFlag()) {
        return 'Для продолжения работы необходимо подписать персональные юридические документы для вашего Агентства. Пожалуйста, ознакомьтесь с ними и подтвердите принятие, чтобы продолжить работу в личном кабинете.';
      }
      var title = 'Для входа в личный кабинет вам необходимо принять политику обработки персональных данных, пользовательское соглашение';
      if (isAgent) {
        return "".concat(title, ", \u0430 \u0442\u0430\u043A\u0436\u0435 \u043E\u0437\u043D\u0430\u043A\u043E\u043C\u0438\u0442\u044C\u0441\u044F \u0441 \u043E\u0444\u0435\u0440\u0442\u043E\u0439 \u0430\u0433\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0438 \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u043E\u0439 \u043E\u0444\u0435\u0440\u0442\u043E\u0439 \u043D\u0430 \u0443\u0447\u0430\u0441\u0442\u0438\u0435 \u0432 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0435 \u043B\u043E\u044F\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \"\u0421\u0442\u0440\u0430\u043D\u0430.\u0411\u0440\u043E\u043A\u0435\u0440\"");
      }
      if (isAggregator.value) {
        return title;
      }
      return "".concat(title, ", \u0430 \u0442\u0430\u043A\u0436\u0435 \u043E\u0444\u0435\u0440\u0442\u0443 \u0430\u0433\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0438 \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u0443\u044E \u043E\u0444\u0435\u0440\u0442\u0443 \u043D\u0430 \u0443\u0447\u0430\u0441\u0442\u0438\u0435 \u0432 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0435 \u043B\u043E\u044F\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \"\u0421\u0442\u0440\u0430\u043D\u0430.\u0411\u0440\u043E\u043A\u0435\u0440\"");
    });
    var legalDocumentsStore = useLegalDocumentsStore();
    var acceptedDocumentsV2 = legalDocumentsStore.acceptedDocumentsV2,
      loadAcceptedLegalDocuments = legalDocumentsStore.loadAcceptedLegalDocuments,
      loadAcceptedLegalDocumentsV2 = legalDocumentsStore.loadAcceptedLegalDocumentsV2,
      sendAcceptedLegalDocument = legalDocumentsStore.sendAcceptedLegalDocument;
    var _useLegalDocuments = useLegalDocuments(),
      documentsSlugsWithRole = _useLegalDocuments.documentsSlugsWithRole;
    var isCheckedPolicy = ref(false);
    var policyChecked = function policyChecked(_ref) {
      var acceptPolicy = _ref.acceptPolicy,
        acceptOffer = _ref.acceptOffer;
      isCheckedPolicy.value = Boolean(acceptPolicy && acceptOffer);
    };
    var loading = ref(false);
    var loadingSend = ref(false);
    var hideAnimationEnded = ref(false);
    var hidingAnimation = ref(false);
    var showComponent = computed(function () {
      return !hideAnimationEnded.value;
    });
    var acceptDocument = fullLogDecorate(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", sendAcceptedLegalDocument(documentsSlugsWithRole()).then(function () {
              loadAcceptedLegalDocuments(documentsSlugsWithRole(true));
              hidingAnimation.value = true;
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), 'ModalAcceptedLegalDocuments');
    var documentSlugsV2 = ref([]);
    var notify = useNotify();
    var acceptDocumentV2 = fullLogDecorate(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", sendAcceptedLegalDocument(documentSlugsV2.value).then(function () {
              loadAcceptedLegalDocumentsV2();
              hidingAnimation.value = true;
            }).catch(function (error) {
              notify.create({
                message: getErrorMessageTyped(error),
                type: 'negative'
              });
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })), 'ModalAcceptedLegalDocuments', true);
    function onSaveButtonClick() {
      return _onSaveButtonClick.apply(this, arguments);
    }
    function _onSaveButtonClick() {
      _onSaveButtonClick = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              loadingSend.value = true;
              if (!isAcceptPrivateFlag()) {
                _context3.next = 2;
                break;
              }
              _context3.next = 1;
              return acceptDocumentV2();
            case 1:
              _context3.next = 3;
              break;
            case 2:
              _context3.next = 3;
              return acceptDocument();
            case 3:
              loadingSend.value = false;
              // hidingAnimation.value = true;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _onSaveButtonClick.apply(this, arguments);
    }
    var $style = useCssModule();
    function onAnimationEnd(e) {
      if (e.animationName === $style['hide-swipe']) {
        hideAnimationEnded.value = true;
        pageScrollService.unlock();
      }
    }
    onBeforeMount(function () {
      if (process.client) {
        pageScrollService.lock();
      }
    });
    onBeforeUnmount(function () {
      pageScrollService.unlock();
    });
    function onAcceptsChange(newValue) {
      isCheckedPolicy.value = Object.values(newValue).every(Boolean);
      if (isCheckedPolicy.value) {
        documentSlugsV2.value = Object.keys(newValue);
      }
    }
    return {
      __sfc: true,
      isAgent: isAgent,
      authStore: authStore,
      isAggregator: isAggregator,
      isAcceptPrivateFlag: isAcceptPrivateFlag,
      description: description,
      legalDocumentsStore: legalDocumentsStore,
      acceptedDocumentsV2: acceptedDocumentsV2,
      loadAcceptedLegalDocuments: loadAcceptedLegalDocuments,
      loadAcceptedLegalDocumentsV2: loadAcceptedLegalDocumentsV2,
      sendAcceptedLegalDocument: sendAcceptedLegalDocument,
      documentsSlugsWithRole: documentsSlugsWithRole,
      isCheckedPolicy: isCheckedPolicy,
      policyChecked: policyChecked,
      loading: loading,
      loadingSend: loadingSend,
      hideAnimationEnded: hideAnimationEnded,
      hidingAnimation: hidingAnimation,
      showComponent: showComponent,
      acceptDocument: acceptDocument,
      documentSlugsV2: documentSlugsV2,
      notify: notify,
      acceptDocumentV2: acceptDocumentV2,
      onSaveButtonClick: onSaveButtonClick,
      $style: $style,
      onAnimationEnd: onAnimationEnd,
      onAcceptsChange: onAcceptsChange,
      SButton: SButton,
      SLoader: SLoader,
      AppTitle: AppTitle,
      GenericAcceptPolicy: GenericAcceptPolicy,
      RegistrationPolicy: RegistrationPolicy
    };
  }
});